(function() {
  let holidaysCache = null;

  async function fetchHolidays() {
    if (holidaysCache) return holidaysCache;
    try {
      const res = await fetch('https://holidays-jp.github.io/api/v1/date.json');
      holidaysCache = await res.json();
    } catch (e) {
      holidaysCache = {};
    }
    return holidaysCache;
  }

  function getDayOfWeek(dateStr) {
    return new Date(dateStr + 'T00:00:00Z').getUTCDay();
  }

  function isWeekendOrHoliday(dateStr, holidays) {
    const dow = getDayOfWeek(dateStr);
    return dow === 0 || dow === 6 || (holidays && dateStr in holidays);
  }

  function addDaysToStr(dateStr, n) {
    const d = new Date(dateStr + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }

  function getShipDateStr(holidays) {
    const now = new Date();
    const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    const hour = jst.getUTCHours();
    let dateStr = jst.toISOString().slice(0, 10);
    if (hour >= 15) dateStr = addDaysToStr(dateStr, 1);
    while (isWeekendOrHoliday(dateStr, holidays)) dateStr = addDaysToStr(dateStr, 1);
    return dateStr;
  }

  function formatDateStr(dateStr) {
    const dow = ['日','月','火','水','木','金','土'];
    const d = new Date(dateStr + 'T00:00:00Z');
    const m = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const w = dow[d.getUTCDay()];
    return m + '月' + day + '日(' + w + ')お届け予定';
  }

  async function getDeliveryText(days) {
    const holidays = await fetchHolidays();
    const shipDateStr = getShipDateStr(holidays);
    const deliveryStr = addDaysToStr(shipDateStr, days);
    return formatDateStr(deliveryStr);
  }

  const shippingData = {
    hokkaido: { price: 1500, days: 2 },
    aomori: { price: 1000, days: 2 },
    iwate: { price: 1000, days: 2 },
    miyagi: { price: 1000, days: 2 },
    akita: { price: 1000, days: 2 },
    yamagata: { price: 1000, days: 2 },
    fukushima: { price: 1000, days: 2 },
    ibaraki: { price: 900, days: 2 },
    tochigi: { price: 900, days: 2 },
    gunma: { price: 900, days: 2 },
    saitama: { price: 900, days: 2 },
    chiba: { price: 900, days: 2 },
    tokyo: { price: 900, days: 2 },
    kanagawa: { price: 900, days: 2 },
    niigata: { price: 900, days: 2 },
    toyama: { price: 900, days: 2 },
    ishikawa: { price: 900, days: 2 },
    fukui: { price: 900, days: 2 },
    yamanashi: { price: 900, days: 2 },
    nagano: { price: 900, days: 2 },
    gifu: { price: 900, days: 2 },
    shizuoka: { price: 900, days: 2 },
    aichi: { price: 900, days: 2 },
    mie: { price: 900, days: 2 },
    shiga: { price: 900, days: 1 },
    kyoto: { price: 900, days: 1 },
    osaka: { price: 900, days: 1 },
    hyogo: { price: 900, days: 1 },
    nara: { price: 900, days: 1 },
    wakayama: { price: 900, days: 1 },
    tottori: { price: 900, days: 1 },
    shimane: { price: 900, days: 1 },
    okayama: { price: 900, days: 1 },
    hiroshima: { price: 900, days: 1 },
    yamaguchi: { price: 900, days: 1 },
    tokushima: { price: 900, days: 1 },
    kagawa: { price: 900, days: 1 },
    ehime: { price: 900, days: 1 },
    kochi: { price: 900, days: 1 },
    fukuoka: { price: 900, days: 1 },
    saga: { price: 900, days: 1 },
    nagasaki: { price: 900, days: 1 },
    kumamoto: { price: 900, days: 1 },
    oita: { price: 900, days: 1 },
    miyazaki: { price: 900, days: 1 },
    kagoshima: { price: 900, days: 1 },
    okinawa: { price: 1500, days: 2 }
  };

  window.ShippingCalculator = { shippingData, getDeliveryText };
})();